import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Tab, Tabs, IconButton, Tooltip } from '@mui/material';
import { ContentCopy } from '@mui/icons-material';
import CodeEditor from '@uiw/react-textarea-code-editor';



function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function TabLenguaje({ curl, csRS, javaOK, phpRQ, csHC, java2UN, php2GZ, id="" }) {
  const [value, setValue] = React.useState(0);
  const [ccurl, setCcurl] = useState(curl);
  const [ccs, setCcs] = useState(csRS);
  const [cjava, setCjava] = useState(javaOK);
  const [cphp, setCphp] = useState(phpRQ);
  const [ccs2, setCcs2] = useState(csHC);
  const [cjava2, setCjava2] = useState(java2UN);
  const [cphp2, setCphp2] = useState(php2GZ);
  const [copyText, setCopyText] = useState('copy');
  const [copyCode, setCopyCode] = useState(curl);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setCopyText('copy');
    switch (newValue) {
      case 0:
        setCopyCode(ccurl);
        break;
      case 1:
        setCopyCode(ccs);
        break;
      case 2:
        setCopyCode(cjava);
        break;
      case 3:
        setCopyCode(cphp);
        break;
      case 4:
        setCopyCode(ccs2);
        break;
      case 5:
        setCopyCode(cjava2);
        break;
      case 6:
        setCopyCode(cphp2);
        break;
      default:
        setCopyCode(ccurl);
    }
  };

  const handleCopyClick = async () => {
    await navigator.clipboard.writeText(copyCode);
    setCopyText('copied!')
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="Curl" {...a11yProps(0)} />
          <Tab label="C# - RestSharp" {...a11yProps(1)} />
          <Tab label="JAVA – OkHttp" {...a11yProps(2)} />
          <Tab label="PHP - HTTP_Request2" {...a11yProps(3)} />
          <Tab label="C# - HTTP Client" {...a11yProps(4)} />
          <Tab label="JAVA - Unirest" {...a11yProps(5)} />
          <Tab label="PHP - Guzzle" {...a11yProps(6)} />
        </Tabs>
        <Box>
          <Tooltip title={copyText}>
            <IconButton aria-label='copy' color='secondary' size="small" onClick={handleCopyClick}>
              <ContentCopy fontSize="inherit" />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>
      <TabPanel value={value} index={0}id={id}>
        <CodeEditor
          //CURL
          value={ccurl}
          data-color-mode="dark"
          language="js"
          placeholder="Please enter curl code."
          onChange={(evn) => setCcurl(evn.target.value)}
          padding={15}
          style={{
            fontSize: 15,
            fontFamily: 'ui-monospace,SFMono-Regular,SF Mono,Consolas,Liberation Mono,Menlo,monospace',
          }}
        />
      </TabPanel>
      <TabPanel value={value} index={1} id={id}>
        <CodeEditor
          //C# RESTSHAR´P
          value={ccs}
          data-color-mode="dark"
          language="cs"
          placeholder="Please enter C# code."
          onChange={(evn) => setCcs(evn.target.value)}
          padding={15}
          style={{
            fontSize: 15,
            fontFamily: 'ui-monospace,SFMono-Regular,SF Mono,Consolas,Liberation Mono,Menlo,monospace',
          }}
        />
      </TabPanel>
      <TabPanel value={value} index={2} id={id}>
        <CodeEditor
          //JAVA OKHTTP
          value={cjava}
          data-color-mode="dark"
          language="java"
          placeholder="Please enter JAVA code."
          onChange={(evn) => setCjava(evn.target.value)}
          padding={15}
          style={{
            fontSize: 15,
            fontFamily: 'ui-monospace,SFMono-Regular,SF Mono,Consolas,Liberation Mono,Menlo,monospace',
          }}
        />
      </TabPanel>
      <TabPanel value={value} index={3} id={id}>
        <CodeEditor
          // PHP REQUEST
          value={cphp}
          data-color-mode="dark"
          language="php"
          placeholder="Please enter PHP code."
          onChange={(evn) => setCphp(evn.target.value)}
          padding={15}
          style={{
            fontSize: 15,
            fontFamily: 'ui-monospace,SFMono-Regular,SF Mono,Consolas,Liberation Mono,Menlo,monospace',
          }}
        />
      </TabPanel>
      <TabPanel value={value} index={4} id={id}>
        <CodeEditor
          //CSHTTPCLIENT
          value={ccs2}
          data-color-mode="dark"
          language="php"
          placeholder="Please enter PHP code."
          onChange={(evn) => setCcs2(evn.target.value)}
          padding={15}
          style={{
            fontSize: 15,
            fontFamily: 'ui-monospace,SFMono-Regular,SF Mono,Consolas,Liberation Mono,Menlo,monospace',
          }}
        />
      </TabPanel>
      <TabPanel value={value} index={5} id={id}>
        <CodeEditor
          //JAVA UNIREST
          value={cjava2}
          data-color-mode="dark"
          language="php"
          placeholder="Please enter PHP code."
          onChange={(evn) => setCjava2(evn.target.value)}
          padding={15}
          style={{
            fontSize: 15,
            fontFamily: 'ui-monospace,SFMono-Regular,SF Mono,Consolas,Liberation Mono,Menlo,monospace',
          }}
        />
      </TabPanel>
      <TabPanel value={value} index={6} id={id}>
        <CodeEditor
          //PHP GUZZLE
          value={cphp2}
          data-color-mode="dark"
          language="php"
          placeholder="Please enter PHP code."
          onChange={(evn) => setCphp2(evn.target.value)}
          padding={15}
          style={{
            fontSize: 15,
            fontFamily: 'ui-monospace,SFMono-Regular,SF Mono,Consolas,Liberation Mono,Menlo,monospace',
          }}
        />
      </TabPanel>
    </Box>
  );
}